<template>
  <div v-if="purchase.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('ReturnPurchases', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="($route.path.startsWith('/return-purchases-approve')
                ? '/#/return-purchases-approve/'
                : '/#/return-purchases/')  + purchase.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("returnPurchase.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          purchase.actions &&
          purchase.actions.return_edit &&
          $permission.permissionAllow('ReturnPurchases', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push('/return-purchases/' + purchase.id + '/edit');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("returnPurchase.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("returnPurchase.actions.editPurchase") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showConfirm &&
          purchase.actions &&
          purchase.actions.return_confirm &&
          $permission.permissionAllow('ReturnPurchases', 'confirm')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('confirm')
                  : $router.push('/return-purchases/' + purchase.id + '/confirm');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("returnPurchase.actions.confirm") }}
          </v-btn>
        </template>
        <span>{{ $t("returnPurchase.actions.confirmPurchase") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove &&
          purchase.actions &&
          purchase.actions.return_approve &&
          $permission.permissionAllow('ReturnPurchases', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('approve')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{
              $t(
                detailMode
                  ? "returnPurchase.actions.approveInDetail"
                  : "returnPurchase.actions.approve"
              )
            }}
          </v-btn>
        </template>
        <span>{{ $t("returnPurchase.actions.approvePurchase") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          purchase.actions &&
          purchase.actions.cancel &&
          $permission.permissionAllow('ReturnPurchases', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("returnPurchase.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("returnPurchase.actions.cancelPurchase") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showPrint && $permission.permissionAllow('ReturnPurchases', 'returnPurchasePrint')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            :href="'/#/print/return-purchases-print/' + purchase.id"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
          </v-btn>
        </template>
        <span>{{ $t("returnPurchase.actions.returnPurchasePrint") }}</span>
      </v-tooltip>
      <!-- 导出退货单 -->
      <v-tooltip
        top
        v-if="showExport && $permission.permissionAllow('ReturnPurchases', 'export')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="toExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("returnPurchase.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("returnPurchase.actions.export") }}</span>
      </v-tooltip>
    </v-sheet>
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('returnPurchase.ObjectName')"
      :code="purchase.purchase_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import ReturnPurchases from "@/api/return_purchases";

export default {
  name: "ReturnPurchaseActions",

  components: {
    DialogDelete,
  },

  props: {
    purchase: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showConfirm: Boolean,
    showRedeliver: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showPrint: Boolean,
    showExport: Boolean,
  },

  computed: {},

  data: () => ({
    printBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "approve") return ReturnPurchases.approve(this.purchase.id);
      else if (mode == "cancel") return ReturnPurchases.cancel(this.purchase.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (this.detailMode)
                  this.$router.push(
                    mode == "approve"
                      ? "/return-purchases-approve"
                      : "/return-purchases"
                  );
                this.$emit("done");
                this.$store.commit("refreshToDos", true);
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    toExport() {
      ReturnPurchases.detailExports(this.purchase.id);
    }
  },
};
</script>